import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const details = gql`
  query ChannelDetailsQuery($slug: String!) {
    channel(slug: $slug) {
      ...ChannelDetails
    }
  }

  ${Fragments.channel.details}
`;

export const listItem = gql`
  query ChannelListItemQuery($slug: String!) {
    channel(slug: $slug) {
      ...ChannelListItem
    }
  }

  ${Fragments.channel.listItem}
`;

export const list = gql`
  query ChannelListQuery($businessId: Int!) {
    me {
      id
      business(businessId: $businessId) {
        id
        name
        channels(filter: CONVERSATIONS) {
          ...ChannelListItem
        }
      }
    }
  }

  ${Fragments.channel.listItem}
`;

export const deletedList = gql`
  query DeletedChannelListQuery($input: ListChannels!) {
    listChannels(input: $input) {
      ...DeletedChannel
    }
  }

  ${Fragments.channel.deletedChannel}
`;

export const listWorkspaceSections = gql`
  query ListWorkspaceSectionsQuery {
    listWorkspaceSections {
      ...WorkspaceSection
    }
  }

  ${Fragments.channel.workspaceSection}
`;

export const listV2 = gql`
  query ListChannelsQuery($input: ListChannels!) {
    listChannels(input: $input) {
      id
      type
      slug
      workflowTemplateId
      channelMemberships {
        ...ChannelMembership
      }
      visible
    }
  }

  ${Fragments.channel.membership}
`;

export const chatThread = gql`
  query ChannelChatThreadQuery(
    $slug: String!
    $since: DateTime
    $limit: Int!
    $fetchMessagesAfterSince: Boolean
  ) {
    channel(slug: $slug) {
      ...ChannelChatThread
    }
  }

  ${Fragments.channel.chatThread}
`;

export const cardDefinitions = gql`
  query ChannelCardDefinitionsQuery($input: ListCardDefinitions!) {
    listCardDefinitions(input: $input) {
      ...CardDefinition
    }
  }

  ${Fragments.card.definition}
`;

export const listReports = gql`
  query ChannelListReportsQuery($input: ListReports!) {
    listReports(input: $input) {
      ...ChannelReport
    }
  }

  ${Fragments.channel.report}
`;

export const getRelatedChannelAssociations = gql`
  query RelatedChannelAssociationsQuery($id: Int!) {
    getChannel(id: $id) {
      slug
      relatedChannelAssociations {
        relatedChannelId
        field
      }
    }
  }
`;

export const getChannel = gql`
  query ChannelQuery($id: Int, $slug: String) {
    channel: getChannel(id: $id, slug: $slug) {
      id
      slug
      type
      workflowTemplateId
      name
      imageUrl
      cardCount
      visible
      description
      defaultFocus
      bundle {
        ...Bundle
      }
    }
  }

  ${Fragments.bundle.bundle}
`;

export const accessLevels = gql`
  query ChannelAccessLevelsQuery {
    accessLevels: listAccessLevels(input: { domain: CHANNEL }) {
      ...AccessLevel
    }
  }

  ${Fragments.user.accessLevel}
`;

export const listSharedCardLinks = gql`
  query ListSharedCardLinksQuery($input: ListSharedCardLinks!) {
    listSharedCardLinks(input: $input) {
      ...SharedCardLink
    }
  }

  ${Fragments.channel.sharedCardLink}
`;

export const dmChannelUsers = gql`
  query DmChannelUsersQuery($input: ListChannels!) {
    listChannels(input: $input) {
      id
      slug
      channelMemberships {
        id
        user {
          id
          fullName
          username
          imageUrl
          isMe
        }
      }
    }
  }
`;

export const listChannelMemberships = gql`
  query ListChannelMembershipsQuery($input: ListChannelMemberships!) {
    listChannelMemberships(input: $input) {
      id
      user {
        ...CollectionViewUser
      }
    }
  }

  ${Fragments.user.collectionViewUser}
`;
